import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from "@vueuse/head";

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';

const head = createHead();
// app.use(head);
createApp(App,createHead).use(router).mount('#app')
// app.use(head);
// app.mount("#app");